import React from 'react'
import { IconMaximize } from '@tabler/icons-react'
import Typography from '../Typography'
import { cn } from '../../../enviroment/lib/utils'

const FullScreenButton: React.FC<{ onClick: () => void; className?: string }> = ({ onClick, className }) => (
  <button
    onClick={onClick}
    className={cn(
      'flex items-center justify-center gap-2 rounded-full p-1 text-gray-50 transition-all duration-200 ease-in-out hover:bg-gray-800',
      className,
    )}
    title="Full Screen"
  >
    <IconMaximize className="h-5 w-5" stroke={2} />
    <Typography variant="sm" className="text-white">
      Full Screen
    </Typography>
  </button>
)

export default FullScreenButton
